import React from 'react'
import { isMobileOnly } from 'react-device-detect'
import { useLocation } from 'react-router-dom'

import OhBackground from 'components/OhBackground'
import { WA_URL } from 'helpers/whatsappURL'

import * as Styles from './styles'

const loginImageUrl =
    'https://res.cloudinary.com/openhouse-study/image/upload/w_1200,f_auto/v1592899415/Dashboard%20Images/loginScreen.svg'

const AuthFormWrapper = props => {
    const location = useLocation()
    const type = location.pathname.split('/')[1]

    return (
        <OhBackground>
            <Styles.LoginContainer>
                {!(type === 'signup' && isMobileOnly) && (
                    <Styles.ImageContainer>
                        <Styles.Image alt="Login Image" src={loginImageUrl} />
                    </Styles.ImageContainer>
                )}
                <Styles.FormContainer>
                    {props?.children}
                    <Styles.TermsAndPrivacyPolicy>
                        <Styles.PolicyLink
                            href="https://openhouse.study/terms-of-service"
                            target="_blank"
                        >
                            terms
                        </Styles.PolicyLink>
                        and
                        <Styles.PolicyLink
                            href="https://openhouse.study/privacy-policy"
                            target="_blank"
                        >
                            privacy policy
                        </Styles.PolicyLink>
                    </Styles.TermsAndPrivacyPolicy>
                </Styles.FormContainer>
                <a href={WA_URL} rel="noreferrer" target="_blank">
                    <Styles.ContactUs />
                </a>
            </Styles.LoginContainer>
        </OhBackground>
    )
}

export default AuthFormWrapper
